<template>
  <div class="finatrade_wrapper">
        <div class="page page1">
          <div class="finatrade_header">
            <h1>合迪股份有限公司交易申請書</h1>
          </div><!--header-->
          <div class="top">
            <div class="top-car">
              車種：機車
            </div><!--top-car-->
            <div class="top-name">
              進件單位：<span></span>
            </div>
            <div class="top-date">
              申請日期：
              <span class="y">{{editedItem.applyDate.year}}</span>年
              <span class="m">{{editedItem.applyDate.month}}</span>月
              <span class="d">{{editedItem.applyDate.day}}</span>日
            </div>
          </div><!--top-->
          <div class="area1">
            <div class="title1">申請<br/>資訊</div>
            <table class="table1">
              <tr>
                <td rowspan="2" width="252px">
                  <span class="tdTit tdTit1">金額：NT$</span>
                  <div class="con1">{{editedItem.vendor.totalPrice}}</div>
                  <span class="tdTit tdTit2">元整</span>
                </td>
                <td class="tdEnd tdDot">
                  <span class="tdTit tdTit3">專案名稱</span>
                  <div class="con2"></div>
                </td>
              </tr>
              <tr>
                <td class="tdEnd">
                  <span class="tdTit tdTit4">期數：</span>
                  <div class="con3">{{editedItem.vendor.installmentsNumber}}</div>
                  <span class="tdTit tdTit5">期</span>
                  <span class="tdTit tdTit6">付款條件：</span>
                  <div class="con4">
                    <div class="checkDiv">
                      <span class="checkbox checkbox1">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img :src="checkedImage"></label>
                      </span>單月付
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox2">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img :src="checkedImage"></label>
                      </span>雙月付&nbsp;(&nbsp;期付款：NT$<span class="con4-0">
                        {{editedItem.vendor.creditPriceMonth}}
                        </span>元&nbsp;)
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox3">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>其他<div class="con4-2"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </table><!--table1-->
            <div class="title2">付款<br/>方式</div>
            <table class="table2">
              <tr>
                <td width="205px">
                  <div class="con5">
                    <div class="checkDiv">
                      <span class="checkbox checkbox4">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.paymentInfo.isBankBillPay" :src="checkedImage">
                        </label>
                      </span>銀行自動扣繳
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox5">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.isPostBillPay"
                         :src="checkedImage"></label>
                      </span>郵局
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox6">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.isAtmBillPay" :src="checkedImage"></label>
                      </span>ATM
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox7">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.isStoreBillPay" :src="checkedImage"></label>
                      </span>超商
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox8">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.isAutoBillPay" :src="checkedImage"></label>
                      </span>ACH
                    </div>
                  </div>
                </td>
                <td>
                  <span class="tdTit tdTit7">繳款單寄送處：</span>
                  <div class="con6">
                    <div class="checkDiv">
                      <span class="checkbox checkbox9">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.debitNote.isRegistration" :src="checkedImage"></label>
                      </span>戶籍地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox10">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.debitNote.isMailingAddress" :src="checkedImage"></label>
                      </span>通訊地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox11">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.debitNote.isCompanyAddress" :src="checkedImage"></label>
                      </span>公司
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox12">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.paymentInfo.debitNote.isOtherAddress" :src="checkedImage"></label>
                      </span>其他<div class="con6-1">
                        {{editedItem.paymentInfo.debitNote.address}}
                      </div>
                    </div>
                  </div>

                </td>
              </tr>
            </table><!--table2-->
            <table class="table3">
              <tr>
                <td width="50px">
                  <div class="con7">
                    <div class="checkDiv">
                      <span class="checkbox checkbox13">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img :src="checkedImage"></label>
                      </span>支票付款
                    </div>
                  </div>
                </td>
                <td width="175px">
                  <span class="tdTit tdTit8">(付款行：</span>
                  <div class="con8 con8-1">{{editedItem.bankName}}</div>
                  <span class="tdTit tdTit9">銀行</span>
                </td>
                <td>
                  <div class="con9 con9-1">{{editedItem.bankSubName}}</div>
                  <span class="tdTit tdTit10">分行</span>
                </td>
              </tr>
            </table><!--table3-->
            <table class="table4">
              <tr>
                <td width="195px">
                  <span class="tdTit tdTit11">帳號：</span>
                  <div class="con10 con10-1">{{editedItem.bankAccount}}</div>
                </td>
                <td width="210px">
                  <span class="tdTit tdTit12">發票人：</span>
                  <div class="con11 con11-1">{{editedItem.customer.name}}</div>
                </td>
                <td width="115px">
                  <span class="tdTit tdTit13">發票日：</span>
                  <div class="con12 con12-1">109/12/30</div>
                </td>
                <td>
                  <span class="tdTit tdTit14">往來情形：</span>
                  <div class="con13">
                    (<div class="con13-1"></div>)
                  </div>
                </td>
              </tr>
            </table><!--table4-->
            <div class="title3-1">手機</div>
            <table class="table5-1">
              <tr>
                <th width="192px"><span class="tdTit tdTit15-1">手機廠牌</span></th>
                <th width="182px"><span class="tdTit tdTit16-1">手機型號</span></th>
                <th class="thEnd"><span class="tdTit tdTit17-1">IMEI碼</span></th>
              </tr>
              <tr>
                <td>{{editedItem.phoneVendor}}</td>
                <td>{{editedItem.phoneModel}}</td>
                <td class="tdEnd">{{editedItem.phoneIMEI}}</td>
              </tr>
            </table><!--table5-->
            <div class="title3-2">車輛</div>
            <table class="table5-2">
              <tr>
                <th width="192px"><span class="tdTit tdTit15">廠牌</span></th>
                <th width="182px"><span class="tdTit tdTit16">車型</span></th>
                <th width="192px"><span class="tdTit tdTit17">車號</span></th>
                <th class="thEnd"><span class="tdTit tdTit18">出廠年/月</span></th>
              </tr>
              <tr>
                <td>{{editedItem.laonhfcInfo.vendor}}</td>
                <td>{{editedItem.laonhfcInfo.name}}</td>
                <td>{{editedItem.laonhfcInfo.carId}}</td>
                <td class="tdEnd">{{editedItem.laonhfcInfo.manufactureDate}}</td>
              </tr>
            </table><!--table5-->
          </div><!--area1-->
          <div class="area2">
            <div class="title1">申請人</div>
            <table class="table6">
              <tr>
                <td width="174px">
                  <span class="tdTit tdTit19">姓名：</span>
                  <div class="con14">{{editedItem.customer.name}}</div>
                </td>
                <td width="165px">
                  <span class="tdTit tdTit20">身分證字號：</span>
                  <div class="con15">{{editedItem.customer.memberId}}</div>
                </td>
                <td width="102px">
                  <div class="con16">
                    <div class="checkDiv">
                      <span class="checkbox checkbox14">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.married[0].value" :src="checkedImage"></label>
                      </span>已婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox15">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.married[1].value" :src="checkedImage"></label>
                      </span>未婚
                    </div>
                  </div>
                </td>
                <td class="tdEnd" width="105px">
                  <span class="tdTit tdTit21">生日：</span>
                  <div class="con17">{{editedItem.customer.birthday}}</div>
                </td>
                <td class="tdBorder">
                  <span class="tdTit tdTit22">視訊照會時間：</span>
                  <div class="con18"></div>
                </td>
              </tr>
            </table><!--table6-->
            <table class="table7">
              <tr>
                <td width="317px">
                  <span class="tdTit tdTit23">戶籍地址：</span>
                  <div class="con19">
                    <div class="checkDiv">
                      <span class="checkbox checkbox16">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.homeType1[0].value" :src="checkedImage"></label>
                      </span>同身分證住址
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox17">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.homeType1[1].value" :src="checkedImage"></label>
                      </span>其他<div class="con19-1">{{editedItem.customer.home.residenceAddress}}</div>
                    </div>
                  </div>
                </td>
                <td width="106px">
                  <span class="tdTit tdTit24">電話：</span>
                  <div class="con20">{{editedItem.customer.homePhone}}</div>
                </td>
                <td width="124px">
                  <span class="tdTit tdTit25">行動電話：</span>
                  <div class="con21">{{editedItem.customer.cellphone}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit26">LINE&nbsp;&nbsp;&nbsp;ID：</span>
                  <div class="con22"></div>
                </td>
              </tr>
            </table><!--table7-->
            <table class="table8">
              <tr>
                <td width="420px" class="tdEnd">
                  <span class="tdTit tdTit27">通訊地址：</span>
                  <div class="con23">
                    <div class="checkDiv">
                      <span class="checkbox checkbox18">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.homeType2[0].value" :src="checkedImage"></label>
                      </span>戶籍
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox19">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.homeType1[1].value" :src="checkedImage"></label>
                      </span>公司地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox20">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.homeType1[2].value"  :src="checkedImage"></label>
                      </span>其他<div class="con23-1">{{editedItem.customer.home.homeAddress1}}</div>
                    </div>
                  </div>
                </td>
                <td width="174px">
                  <span class="tdTit tdTit28">電話：</span>
                  <div class="con24">{{editedItem.firstContact.homePhone}}</div>
                </td>
                <td class="tdEnd">
                  <div class="con25">
                    <div class="checkDiv">
                      <span class="checkbox checkbox21">
                        <input type="checkbox" disabled="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                      <div class="con25-1"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </table><!--table8-->
            <table class="table9">
              <tr>
                <td width="375px">
                  <span class="tdTit tdTit29">現居地住</span>
                  <div class="con26-1">{{editedItem.customer.home.liveYear}}</div>
                  <span class="tdTit tdTit30">年</span>
                  <div class="con27">
                    <div class="checkDiv">
                      <span class="checkbox checkbox22">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.liveLevel[0].value" :src="checkedImage"></label>
                      </span>自有/配偶所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox23">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.liveLevel[2].value" :src="checkedImage"></label>
                      </span>父母/子女所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox24">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.liveLevel[3].value" :src="checkedImage"></label>
                      </span>租賃
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox25">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.customer.home.liveLevel[4].value" :src="checkedImage"></label>
                      </span>其他<div class="con27-1"></div>
                    </div>
                  </div>
                </td>
                <td width="121px">
                  <span class="tdTit tdTit31">任職公司：</span>
                  <div class="con28">
                    <div class="con28-1">{{editedItem.company.name}}</div>
                  </div>
                </td>
                <td width="98px">
                  <span class="tdTit tdTit32">職稱：</span>
                  <div class="con29">
                    <div class="con29-1">{{editedItem.company.title}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit33">公司電話：</span>
                  <div class="con30">{{editedItem.company.phone}}</div>
                </td>
              </tr>
            </table><!--table9-->
            <table class="table10">
              <tr>
                <td width="133px">
                  <span class="tdTit tdTit34">年收入&nbsp;&nbsp;NT$</span>
                  <div class="con31">{{editedItem.company.yearSalary}}</div>
                  <span class="tdTit tdTit35">萬</span>
                </td>
                <td width="59px">
                  <span class="tdTit tdTit36">年資</span>
                  <div class="con32">{{editedItem.company.workYear}}</div>
                  <span class="tdTit tdTit37">年</span>
                </td>
                <td width="108px">
                  <span class="tdTit tdTit38">學歷：</span>
                  <div class="con33"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit39">公司地址：</span>
                  <div class="con34">{{editedItem.company.address}}</div>
                </td>
              </tr>
            </table><!--table10-->
          </div><!--area2-->
          <div class="area3">
            <div class="title1">連帶保證人</div>
            <table class="table11">
              <tr>
                <td width="140px">
                  <span class="tdTit tdTit40">姓名：</span>
                  <div class="con35">{{editedItem.jointGuarantor.name}}</div>
                </td>
                <td width="154px">
                  <span class="tdTit tdTit41">身分證字號：</span>
                  <div class="con36">{{editedItem.jointGuarantor.memberId}}</div>
                </td>
                <td width="92px">
                  <div class="con37">
                    <div class="checkDiv">
                      <span class="checkbox checkbox26">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                          </label>
                      </span>已婚
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox27">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>未婚
                    </div>
                  </div>
                </td>
                <td width="90px">
                  <span class="tdTit tdTit42">生日：</span>
                  <div class="con38">{{editedItem.jointGuarantor.birthday}}</div>
                </td>
                <td width="69px" class="tdEnd">
                  <span class="tdTit tdTit43">關係：</span>
                  <div class="con39">{{editedItem.jointGuarantor.type}}</div>
                </td>
                <td class="tdBorder">
                  <span class="tdTit tdTit44">視訊照會時間：</span>
                  <div class="con40"></div>
                </td>
              </tr>
            </table><!--table11-->
            <table class="table12">
              <tr>
                <td width="317px">
                  <span class="tdTit tdTit45">戶籍地址：</span>
                  <div class="con41">
                    <div class="checkDiv">
                      <span class="checkbox checkbox28">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.homeType1[0].value" :src="checkedImage">
                        </label>
                      </span>同身分證住址
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox29">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.homeType1[1].value" :src="checkedImage">
                        </label>
                      </span>其他<div class="con41-1">{{editedItem.jointGuarantor.home.residenceAddress}}</div>
                    </div>
                  </div>
                </td>
                <td width="106px">
                  <span class="tdTit tdTit46">電話：</span>
                  <div class="con42">{{editedItem.jointGuarantor.phone}}</div>
                </td>
                <td width="124px">
                  <span class="tdTit tdTit47">行動電話：</span>
                  <div class="con43">{{editedItem.jointGuarantor.cellphone}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit48">LINE&nbsp;&nbsp;&nbsp;ID：</span>
                  <div class="con44"></div>
                </td>
              </tr>
            </table><!--table12-->
            <table class="table13">
              <tr>
                <td width="450px" class="tdEnd">
                  <span class="tdTit tdTit49">通訊地址：</span>
                  <div class="con45">
                    <div class="checkDiv">
                      <span class="checkbox checkbox30">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.homeType2[0].value" :src="checkedImage">
                        </label>
                      </span>戶籍
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox31">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.homeType2[1].value" :src="checkedImage">
                        </label>
                      </span>公司地
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox32">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <img v-if="editedItem.jointGuarantor.home.homeType2[2].value" :src="checkedImage">
                        </label>
                      </span>其他<div class="con45-1">{{editedItem.jointGuarantor.home.homeAddress1}}</div>
                    </div>
                  </div>
                </td>
                <td width="134px">
                  <span class="tdTit tdTit50">電話：</span>
                  <div class="con46">{{editedItem.jointGuarantor.homePhone}}</div>
                </td>
                <td class="tdEnd">
                  <div class="con47">
                    <div class="checkDiv">
                      <span class="checkbox checkbox33">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                      <div class="con47-1"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </table><!--table13-->
            <table class="table14">
              <tr>
                <td width="339px">
                  <span class="tdTit tdTit51">現居地住</span>
                  <div class="con48">{{editedItem.jointGuarantor.home.liveYear2}}</div>
                  <span class="tdTit tdTit52">年</span>
                  <div class="con49">

                    <div class="checkDiv">
                      <span class="checkbox checkbox34">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel2[0].value" :src="checkedImage"></label>
                      </span>自有/配偶所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox35">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel2[2].value" :src="checkedImage"></label>
                      </span>父母/子女所有
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox36">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel2[3].value" :src="checkedImage"></label>
                      </span>租賃
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox37">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1"><img v-if="editedItem.jointGuarantor.home.liveLevel2[5].value" :src="checkedImage"></label>
                      </span>其他<div class="con49-1"></div>
                    </div>
                  </div>
                </td>
                <td width="245px">
                  <span class="tdTit tdTit53">學歷</span>
                  <div class="con50">
                    <div class="checkDiv">
                      <span class="checkbox checkbox38">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>研究所
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox39">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>大學&nbsp;/&nbsp;大專
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox40">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>高中職
                    </div>
                    <div class="checkDiv">
                      <span class="checkbox checkbox41">
                        <input type="checkbox" disabled="" checked="" id="checkbox-1">
                        <label for="checkbox-1">
                          <!-- <img :src="checkedImage"> -->
                        </label>
                      </span>初中及以下
                    </div>
                  </div>
                </td>
                <td width="99px">
                  <span class="tdTit tdTit54">年收入&nbsp;NT$</span>
                  <div class="con51"></div>
                  <span class="tdTit tdTit55">萬</span>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit56">年資</span>
                  <div class="con52"></div>
                  <span class="tdTit tdTit57">年</span>
                </td>
              </tr>
            </table><!--table14-->
            <table class="table15">
              <tr>
                <td width="152px">
                  <span class="tdTit tdTit58">任職公司：</span>
                  <div class="con53">
                    <div class="con53-1">{{editedItem.jointGuarantor.companyName}}</div>
                  </div>
                </td>
                <td width="108px">
                  <span class="tdTit tdTit59">職稱：</span>
                  <div class="con54">
                    <div class="con54-1">{{editedItem.jointGuarantor.title}}</div>
                  </div>
                </td>
                <td width="345px" class="tdEnd">
                  <span class="tdTit tdTit60">公司地址：</span>
                  <div class="con55">
                    <div class="con55-1">{{editedItem.jointGuarantor.companyAddress}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit61">電話：</span>
                  <div class="con56">{{editedItem.jointGuarantor.companyPhone}}</div>
                </td>
              </tr>
            </table><!--table15-->
          </div><!--area3-->
          <img
            class="signbox"
            :src="signImageSrc('customer')"
          />

          <img
              class="signbox"
              :src="signImageSrc('jointGuarantor')"
            />
        </div><!--page1-->

      </div><!--wrapper-->
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "FinatradeTemplateView",
  props: {
    item: Object
  },
  data() {
    return {
      checkedImage: require('../../assets/images/checked.png'),
      createDate: '',
    }
  },
  computed: {
    editedItem() {
      return this.item;
    },
    // getManufactureDate() {
    //   if (!this.editedItem.laonhfcInfo.publicYear && !this.editedItem.laonhfcInfo.publicMonth) {
    //     return ''
    //   }
    //   const publicYear = this.editedItem.laonhfcInfo.publicYear;
    //   return `${publicYear}/${this.editedItem.laonhfcInfo.publicMonth}`
    // },
    // getYearSalary() {
    //   return parseInt(this.editedItem.company.salary * 12) / 10000
    // }
  },
  methods:{
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.signImage0) {
          source = this.editedItem.signImage0;
        } else if (this.editedItem.signimage0Url) {
          source = this.editedItem.signimage0Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
  }
}
</script>
<style scoped src="../../assets/css/finatrade_template.css">
</style>
<style scoped>
.page1 .top .top-date span,
      .page1 .con1,
      .page1 .con2,
      .page1 .con3,
      .page1 .con4 .con4-2,
      .page1 .con6 .con6-1,
      .page1 .con8-1,
      .page1 .con9-1,
      .page1 .con10-1,
      .page1 .con11-1,
      .page1 .table5 tr td,
      .page1 .con14,
      .page1 .con15,
      .page1 .con17,
      .page1 .con18,
      .page1 .con20,
      .page1 .con21,
      .page1 .con22,
      .page1 .con23-1,
      .page1 .con24,
      .page1 .con25-1,
      .page1 .con26-1,
      .page1 .con30,
      .page1 .con31,
      .page1 .con32,
      .page1 .con33,
      .page1 .con34,
      .page1 .con35,
      .page1 .con36,
      .page1 .con38,
      .page1 .con39,
      .page1 .con40,
      .page1 .con41-1,
      .page1 .con42,
      .page1 .con43,
      .page1 .con44,
      .page1 .con45-1,
      .page1 .con46,
      .page1 .con47-1,
      .page1 .con48,
      .page1 .con49-1,
      .page1 .con51,
      .page1 .con52,
      .page1 .con53-1,
      .page1 .con54-1,
      .page1 .con55-1,
      .page1 .con56
       { color:#0505da;}
  .signbox {
    position: absolute;
    margin-left:10px;
    width: 125px; height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/web/FinatradeTemplateView.vue